<template>
  <div class="greenEnergy_box">
    <div class="head_nav">
      <!-- <div class="title">每人每天省</div>
      <div class="slogan">一度电</div> -->
    </div>
    <div class="content_nav">
      <div class="app_scenario">
        <div class="label_box">
          <!-- <img src="../assets//img/imageNew/greenEnergy/text.png" alt="" class="label_logo"> -->
          <div style="display: flex;align-items: baseline;">
            <div class="label">应用场景</div>
            <div class="en_label">Application scenario</div>
          </div>
          <!-- <div class="left_fun">
            <div class="fun_li">
              <div class="fun_t">微公益</div>
              <div class="fun_s">捐赠积分献大爱</div>
            </div>
            <div class="fun_li">
              <div class="fun_t">免费出行</div>
              <div class="fun_s">免费酒店自由飞</div>
            </div>
            <div class="fun_li">
              <div class="fun_t">礼品兑换</div>
              <div class="fun_s">海量礼品自由换</div>
            </div>
            <div class="fun_li">
              <div class="fun_t">免费好礼</div>
              <div class="fun_s">免费多次领取</div>
            </div>
          </div>
          <div class="flat_patternmaking_box">
            <img src="https://lanhu-oss-proxy.lanhuapp.com/SketchPnge9c10fccf85c6dc47fd4e479dfd1b48fa46baec0d1ab7b5671c81fa3c4a9fd87" alt="">
          </div> -->
        </div>
        
        <div class="menu_box">
          <div class="function_box">
            <div class="label">主要功能</div>
            <div class="en_label">The main function</div>
          </div>
          <div class="item_box">
            <div class="item" v-for="item in menuList" :key="item.icon">
              <img :src="(item.icon)" alt="">
              <div class="label">{{ item.label }}</div>
              <div class="description">{{ item.description }}</div>
              <div class="heng"></div>
              <div class="heng1"></div>
            </div>
          </div>
        </div>

        <div class="wgy">
          <div class="function_box">
            <div class="label">微公益</div>
            <div class="en_label">Micro public welfare</div>
          </div>
          <div class="wgy_content">
            <div class="wgy_left">
              <div class="w_h">安民乡市中心小学</div>
              <div class="w_s">
                <img src="../assets/img/address_icon.png" alt="">
                丽水市松阳县安民乡大潘坑村
              </div>
              <div class="w_t">安民乡中心小学位于松阳县西南山区，交通不便，气候高寒。当地主要以农业收入为主，收入单一，学生家庭大多条件艰苦，父母双方外出打工的家庭很多。
                <br/><br/>据校长陈梦倩介绍，全校有六个年级一个幼儿班共46名学生，13名教师，由于交通不便，学生和老师都是一周只回家一次。</div>
            </div>
            <img class="wgy_img" src="https://sys.huwei.xin:7443/huwei-website/swipper/01.jpg">
          </div>
        </div>
        <div class="public_text">
          <div class="text_left">
            <img src="../assets/img/logo.png" alt="" class="text_logo">
            <div>
              杭州互为综合能源服务有限公司，始终秉承“源于社会回馈社会”的社会责任理念，大力倡导和发展绿色低碳事业，积极发起并参与教育、环保、慈善等社会公益项目。<br/><br/>
              活动以宣传  “每人每天省一度电”  为中心，教育孩子们从小低碳生活安全用电的同时，还给安民乡中心小学的小朋友们带来了许多生活及学习的用品。<br/><br/>
              相信未来，杭州互为能够帮助到更多像安民乡中心小学一样的学校，继续拓展帮扶渠道，丰富帮扶载体，加大帮扶深度和力度，为改造乡村学校教育环境做出贡献，
              更希望能够通过努力，感召更多的社会力量和爱心人士，参与到帮助山区学校和孩子的公益事业中，让学校条件越来越好，让孩子们都能走出山区。
            </div>
          </div>
          <div class="text_right">
            “逐梦成长 筑梦未来”<br/>主题捐助活动
          </div>
        </div>
        <div class="text_slogan">为实现“每人每天省一度电”的愿景，推广“绿能派”移动应用，建立绿能积分体系，为参与绿能派成员积累碳资产。</div>
        <div class="text_more">更多公益筹备中…</div>
      </div>
    </div>
  </div>
</template>
<script>
import { useStore } from "vuex";
import { computed, ref, getCurrentInstance   } from "vue";
export default {
  name: "greenEnergy",
  components: {
  },
  setup() {
    const dom = getCurrentInstance()
    const state = computed(() => useStore().state.client);
    const menuList = ref([
      {
        icon: `https://sys.huwei.xin:7443/huwei-website/imageNew/greenEnergy/i1.png`,
        label: '签住中心',
        description: '用户在酒店登记入住和退房时，同步在产品上签住和签出，动态展示客房用电数据及能耗排名，预计绿能积分。'
      },
      {
        icon: `https://sys.huwei.xin:7443/huwei-website/imageNew/greenEnergy/i2.png`,
        label: '积分管理',
        description: '住宿期间预计绿能积分，退房签出后奖励积分，可随时用于积分兑换精美礼品，或捐献积分参加微公益。'
      },
      {
        icon: `https://sys.huwei.xin:7443/huwei-website/imageNew/greenEnergy/i3.png`,
        label: '微公益',
        description: '由绿能派平台发起助学、环保等公益活动，所有用户参与共建，捐献积分不受限制，达成目标后在线下开展并公示结果。'
      },
    ])
    return {
      dom,
      state,
      menuList
    }
  }
}
</script>
<style lang="scss" scoped>
.greenEnergy_box {
  width: 100%;
  .head_nav {
    background: url('https://sys.huwei.xin:7443/huwei-website/imageNew/greenEnergy/banner.png') no-repeat 100% 100%;
    background-size: cover;
    width: 100%;
    height: 400px;
    display: flex;
    justify-content: center;
    flex-direction: column;
    color: #ffffff;
    box-sizing: border-box;
    padding-left: 200px;
    font-weight: 800;
    .title {
      font-size: 50px;
      color: #FFFFFF;
      line-height: 84px;
    }
    .slogan {
      font-size: 50px;
      color: #00B386;
      line-height: 84px;
    }
  }
  .content_nav {
    position: relative;
    .app_scenario {
      .label_box {
        background-image: url('https://sys.huwei.xin:7443/huwei-website/imageNew/greenEnergy/bg.png');
        background-repeat: no-repeat;
        background-size: 100%;
        background-position:bottom 0 right 0;
        height: 1215px;
        padding: 100px 200px;
        box-sizing: border-box;
        position: relative;
        .label_logo{
          position: absolute;
          left: 227px;
          bottom: 90px;
          width: 232px;
        }
        .left_fun{
          margin-top: 330px;
          width: 800px;
          height: 500px;
          display: flex;
          flex-wrap: wrap;
          .fun_li{
            position: relative;
            padding-left: 30px;
            color: #fff;
            margin-right: 150px;
            .fun_img{
              position: absolute;
              left: -30px;
              top: 8px;
              width: 40px;
            }
            .fun_t{
              font-size: 40px;
              line-height: 55px;
              margin-bottom: 26px;
            }
            .fun_s{
              font-size: 24px;
              line-height: 30px;
              font-weight: 200;
            }
          }
        }
        .label {
          font-size: 40px;
          font-weight: 800;
          color: #132F59;
          line-height: 55px;
          padding-left: 8px;
        }
        .en_label {
          font-size: 22px;
          color: #656973;
          line-height: 22px;
          padding: 8px 12px;
          font-weight: 200;
        }
        .spherical {
          position: relative;
          width: 229px;
          height: 229px;
          background: #1566FF50;
          border-radius: 50%;
          top: 100px;
          left: 282px;
        }
        .spherical::before {
          content: '';
          position: absolute;
          width: 57px;
          height: 57px;
          background: #1566FF;
          border-radius: 50%;
          top: -150px;
          left: 547px;
        }
        .spherical::after {
          content: '';
          position: absolute;
          width: 20px;
          height: 20px;
          // background: #1566FF;
          border: 6px solid #1566FF;
          border-radius: 50%;
          top: -80px;
          left: 627px;
        }
      }
      .flat_patternmaking_box {
        position: absolute;
        right: 120px;
        bottom: 160px;
        img {
          width: 676px;
        }
      }
      .menu_box {
        background: linear-gradient( 180deg, #F4FAFF 0%, #FFFFFF 100%);
        height: 656px;
        padding: 100px 0 0 200px;
        box-sizing: border-box;
        .function_box {
          display: flex;
          align-items: baseline;
          margin-bottom: 100px;
          .label {
            font-size: 40px;
            font-weight: 800;
            color: #132F59;
            line-height: 55px;
            padding-left: 8px;
          }
          .en_label {
            font-size: 22px;
            color: #656973;
            line-height: 22px;
            padding: 8px 12px;
            font-weight: 200;
          }
        }
        .item_box {
          width: 100%;
          display: flex;
          justify-content: space-between;
          box-sizing: border-box;
          padding-right: 200px;
          
          .item {
            width: 473px;
            height: 301px;
            background: #FFFFFF;
            border-radius: 4px;
            padding: 40px 45px 35px;
            box-sizing: border-box;
            text-align: center;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            position: relative;
            border: 1px solid #D8FAFF;
            .heng{
              position: absolute;
              width: 80%;
              height: 3px;
              background: #1667FF;
              bottom: 0;
              left: 0;
            }
            .heng1{
              position: absolute;
              width: 20%;
              height: 3px;
              background: #00B386;
              bottom: 0;
              right: 0;
            }
            img {
              width: 60px;
              height: 60px;
            }
            .label {
              font-size: 24px;
              font-weight: 600;
              color: #000000;
              line-height: 33px;
              padding: 20px 0 10px;
            }
            .description {
              font-size: 18px;
              font-weight: 100;
              color: #000000;
              line-height: 28px;
              padding-top: 8px;
              text-align: left;
            }
          }
        }
      }
      .wgy{
        background-image: url('https://sys.huwei.xin:7443/huwei-website/imageNew/index/wgy_bg.png');
        background-repeat: no-repeat;
        background-size: 1580px 633px;
        background-position:bottom 0 left 0;
        height: 888px;
        padding: 100px 200px 0 ;
        box-sizing: border-box;
        .function_box {
          display: flex;
          align-items: baseline;
          margin-bottom: 180px;
          .label {
            font-size: 40px;
            font-weight: 800;
            color: #132F59;
            line-height: 55px;
            padding-left: 8px;
          }
          .en_label {
            font-size: 22px;
            color: #656973;
            line-height: 22px;
            padding: 8px 12px;
            font-weight: 200;
          }
        }
        .wgy_content{
          width: 100%;
          background: #fff;
          padding: 33px 20px;
          display: flex;
          justify-content: space-between;
          .wgy_left{
            width: 600px;
            padding-left: 40px;
            display: flex;
            flex-direction: column;
            justify-content: center;
            .w_h{
              font-size: 40px;
              color: #132F59;
              line-height: 55px;
              font-weight: bold;
            }
            .w_s{
              font-size: 20px;
              color: #656973;
              line-height: 20px;
              margin-top: 14px;
              margin-bottom: 60px;
              display: flex;
              align-items: center;
              img{
                width: 20px;
                height: 20px;
                margin-right: 12px;
              }
            }
            .w_t{
              font-size: 18px;
              color: #656973;
              line-height: 27px;
            }
          }
          .wgy_img{
            width: 686px;
            height: 406px;
            object-fit: cover;
          }
        }
      }
      .public_text{
        width: 1920px;
        height: 509px;
        background: #FFFFFF;
        padding: 100px 200px 0;
        box-sizing: border-box;
        display: flex;
        justify-content: space-between;
        .text_left{
          width: 958px;
          font-size: 18px;
          font-weight: 400;
          color: #656973;
          line-height: 25px;
          .text_logo{
            width: 150px;
            margin-bottom: 38px;
          }
        }
        .text_right{
          text-align: right;
          font-size: 32px;
          color: #132F59;
          line-height: 40px;
          font-weight: 800;
        }
      }
      .text_slogan {
        width: 100%;
        height: 200px;
        background: url(https://sys.huwei.xin:7443/huwei-website/imageNew/greenEnergy/t_bg.png) 0 0 no-repeat;
        background-size: 100% 100%;
        line-height: 200px;
        text-align: center;
        font-size: 24px;
        color: #3D3F55;
        font-weight: bold;
      }
      .text_more {
        width: 394px;
        height: 81px;
        border-radius: 10px;
        opacity: 0.29;
        border: 1px solid #1667FF;
        font-size: 28px;
        color: #4F8CFF;
        line-height: 38px;
        display: flex;
        justify-content: center;
        align-items: center;
        margin: 50px auto 100px;
      }
      .member_rights {
        height: 945px;
        .rights_menu {
          display: flex;
          width: 100%;
          flex-wrap: wrap;
          .text_box {
            display: flex;
            flex-direction: column;
            width: 377px;
            height: 271px;
            background: #FFFFFF;
            justify-content: center;
            align-items: center;
            .slogan {
              font-size: 24px;
              color: #3C3B3Bc9;
            }
            .text_title {
              font-size: 28px;
              font-weight: bold;
              padding-top: 15px;
              color: #333333;
            }
          }
          .img_box {
            img {
              width: 378px;
              height: 271px;
            }
          }
        }
      }
      .popularize_nav {
        height: 1351px;
        background: #FAFAFA;
        .text_bg {
          position: absolute;
          width: 883px;
          font-size: 200px;
          font-weight: bold;
          color: #F2F2F2;
          line-height: 180px;
          padding: 36px 20px;
        }
        .function_box {
          padding: 153px 208px 80px;
          position: relative;
          float: right;
          .label {
            font-size: 24px;
            font-weight: 800;
            color: #0F0F0F;
            line-height: 30px;
            text-align: right;
            border-right: 4px solid #1667FF;
            padding-right: 8px;
          }
          .en_label {
            font-size: 18px;
            font-weight: 600;
            color: #5E6070;
            line-height: 22px;
            padding: 8px 12px;
            font-weight: 200;
          }
        }
        .content_box {
          position: absolute;
          display: grid;
          grid-template-columns: repeat(2,1fr);
          padding: 269px 208px 0 52px;
          grid-gap: 210px;
          .img_box {
            text-align: end;
            .img1 {
              width: 668px;
              height: 437px;
            }
            .inline_img {
              position: relative;
              width: 820px;
              display: flex;
              padding-top: 32px;
              .img2 {
                width: 432px;
                height: 380px;
                padding-right: 40px;
              }
              .img3 {
                width: 346px;
                height: 454px;
              }
            }
          }
          .text_content {
            text-align: right;
            padding-top: 75px;
            .title {
              font-size: 24px;
              font-weight: 500;
              color: #474747;
              line-height: 33px;
            }
            .content {
              font-size: 18px;
              font-weight: 100;
              color: #474747;
              line-height: 25px;
              padding-top: 36px;
            }
          }
        }
      }
    }
  }
}
</style>